import { DocumentPlusIcon } from "@heroicons/react/24/outline";
import {
  Button,
  Container,
  Group,
  Paper,
  rem,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "../../components/common/Breadcrumb";
import { ROUTES } from "../../constants/routes";
import { BenchImportSection } from "../../features/bench-import/BenchImportSection";
import { useTranslation } from "../../hooks/useTranslation";

export function OperationsCVManagement() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container size="xl" py="xl">
      <Stack gap="xs" mb="xl">
        <Breadcrumb
          items={[
            { label: "Operations Panel", href: "/operations" },
            { label: "CV Management", isActive: true },
          ]}
        />
        <Title order={1} size="h2" fw={700}>
          CV Management
        </Title>
        <Text c="dimmed" size="lg">
          Create and manage CVs
        </Text>
      </Stack>

      <Paper p="md" withBorder>
        <Stack>
          <Title order={3} size="h4" fw={600}>
            Create New CV
          </Title>
          <Text size="sm">
            Create a new CV for someone in the organization. This will open the
            CV editor where you can add personal information, work experience,
            skills, and more.
          </Text>
          <Group>
            <Button
              size="lg"
              leftSection={
                <DocumentPlusIcon style={{ width: rem(18), height: rem(18) }} />
              }
              onClick={() => navigate(ROUTES.CV_NEW)}
              color="brand"
            >
              {t("HEADER_NEW_CV")}
            </Button>
          </Group>
        </Stack>
      </Paper>


      <BenchImportSection />
    </Container>
  );
}
